import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> =  [
  {
    path: '/partners',
    component: () => import('@/views/Partners/Index.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
    }
  },
]

export default routes;